import errorHandler from 'utils/errorReporting'

export const pageView = ({ url, title = '' }) => {
  try {
    if (typeof window === 'undefined' || !window.analytics) return

    window.analytics.page({
      url,
      title,
    })
  } catch (err) {
    errorHandler.report(err)
  }
}

export const identify = () => {
  try {
    if (typeof window === 'undefined' || !window.analytics) return

    const id = localStorage.getItem('userId')
    const name = localStorage.getItem('userName')
    const email = localStorage.getItem('email')
    const companyName = localStorage.getItem('companyName')

    window.analytics.identify({
      id,
      name,
      email,
      companyName,
    })
  } catch (err) {
    errorHandler.report(err)
  }
}

export const event = ({ action, category, label, value, ...props }) => {
  try {
    if (typeof window === 'undefined' || !window.analytics) return

    const userId = localStorage.getItem('userId') ?? 'anonymousId'

    window.analytics.track({
      userId,
      event: action,
      category,
      label,
      value,
      ...props,
    })
  } catch (err) {
    errorHandler.report(err)
  }
}

export default { pageView, identify, event }
